<template>
  <sameday-requester
    :params="params"
    v-slot="{ services }"
    @on:loaded="$emit('on:loaded')"
  >
    <sameday-item-card :loading="false" :params="params">
      <sameday-services
        :params="params"
        :services="services"
        :search="search"
        @on:form="$emit('on:form', $event)"
        @has:services="$emit('has:services', $event)"
      ></sameday-services>
    </sameday-item-card>
  </sameday-requester>
</template>

<script>
import SamedayRequester from "@/components/Sameday/SamedayItemRequest.vue";
import SamedayServices from "@/components/Sameday/SamedayServices.vue";
import SamedayItemCard from "@/components/Sameday/SamedayItemCard.vue";

export default {
  components: {
    SamedayRequester,
    SamedayServices,
    SamedayItemCard,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    search: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
